export default __webpack_public_path__ + "static/media/cholet9.619d865e.jpg";